
import { FileUploadDTO } from "api/FilesApi";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";

export interface FileDialogProps {
    visible: boolean;
    setVisible: (v: boolean) => void;
    currentFile?: FileUploadDTO;
    setCurrentFile: (f: FileUploadDTO ) => void;
}

export function validateTags(tags: string[]) {
    for (const tag of tags) {
        if(!tag.match(/^[a-zA-Z0-9 ]+$/)) {
            easasAlert({
              summary: "Tags can only contain letters and numbers",
              severity: "warn",
            });
            return;
        }
    }
}

